import { render, staticRenderFns } from "./FilialSettingsForm.vue?vue&type=template&id=3156e2ea&scoped=true&"
import script from "./FilialSettingsForm.vue?vue&type=script&lang=js&"
export * from "./FilialSettingsForm.vue?vue&type=script&lang=js&"
import style0 from "./FilialSettingsForm.vue?vue&type=style&index=0&id=3156e2ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3156e2ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VRow,VSelect,VSwitch,VTextField})
